import React from 'react';
import { Brochure } from './pages/Brochure';
export function App() {
  return <Brochure data-id="element-0" />;
}